import React, { useState, useEffect } from 'react';
import Button from '../../../../../ui/canon/Button';
import { CheckIcon } from 'lucide-react';

const ComparisonWidget = ({ onAnswer, disabled, options = [], initialValue = null }) => {
  const [selected, setSelected] = useState(initialValue);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    setSelected(initialValue);
    setIsSubmitting(false);
  }, [initialValue]);

  const handleSelect = (optionTitle) => {
    setSelected(optionTitle);
    if (!isSubmitting) {
        setIsSubmitting(true);
        setTimeout(() => {
            onAnswer({ value: optionTitle });
        }, 500);
    }
  };

  return (
    <div className="grid gap-2.5 sm:grid-cols-2">
      {options.map((option) => (
        <div
          key={option.title}
          onClick={() => !disabled && !isSubmitting && handleSelect(option.title)}
          className={`cursor-pointer border rounded-lg p-3 transition-all ${
            selected === option.title
              ? 'border-succession-primary bg-succession-primary/5 ring-1 ring-succession-primary/20'
              : 'border-succession-border bg-succession-bg-primary hover:border-succession-primary/50'
          }`}
        >
          <div className="flex justify-between items-start mb-1.5">
            <h4 className="font-medium text-sm text-succession-text-primary">{option.title}</h4>
            {selected === option.title && <CheckIcon className="h-4 w-4 text-succession-primary" />}
          </div>
          <ul className="space-y-0.5 text-xs text-succession-text-secondary">
            {option.features && option.features.map((feature, idx) => (
              <li key={idx} className="flex items-center">
                <span className="mr-1.5">•</span>
                {feature}
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
};

export default ComparisonWidget;
